module.exports = __webpack_public_path__ + "img/Expired.796a8973.svg";